import { render, staticRenderFns } from "./NewExp.vue?vue&type=template&id=8ef12354&scoped=true"
import script from "./NewExp.vue?vue&type=script&lang=js"
export * from "./NewExp.vue?vue&type=script&lang=js"
import style0 from "./NewExp.vue?vue&type=style&index=0&id=8ef12354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef12354",
  null
  
)

export default component.exports